import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";
import { TicketCompletionCodeRestService } from "@app/services/hal/ticket-completion-code-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class TicketCompletionCodeStore extends RealTimeDataStore<TicketCompletionCode> {
  constructor() {
    const ticketCompletionCodeRestService = inject(
      TicketCompletionCodeRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      ticketCompletionCodeRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    // super.subscribeToMessaging('Ticket');
  }
}
